import React, { useState } from 'react';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
  className?: string;
}

const FAQ: React.FC<FAQProps> = ({ 
  items,
  className = ''
}) => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  if (!items || items.length === 0) {
    return null;
  }

  const toggleItem = (id: number) => {
    if (openItems.includes(id)) {
      setOpenItems(openItems.filter(itemId => itemId !== id));
    } else {
      setOpenItems([...openItems, id]);
    }
  };

  return (
    <div className={`bg-gray-800 rounded-lg shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">Frequently Asked Questions</h3>
      
      <div className="space-y-4">
        {items.map(item => (
          <div key={item.id} className="border border-gray-700 rounded-lg overflow-hidden">
            <div 
              className="flex justify-between items-center p-4 bg-gray-750 cursor-pointer hover:bg-gray-700 transition"
              onClick={() => toggleItem(item.id)}
            >
              <h4 className="font-medium">{item.question}</h4>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className={`h-5 w-5 transform transition-transform ${
                  openItems.includes(item.id) ? 'rotate-180' : ''
                }`} 
                viewBox="0 0 20 20" 
                fill="currentColor"
              >
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            
            {openItems.includes(item.id) && (
              <div className="p-4 bg-gray-800">
                <p className="text-gray-300">{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;